import { HOST, VERSION } from "../constants"

const BASE = `${HOST}${VERSION}admin/soporte`

export const list = `${BASE}/list`
export const getOne = `${BASE}/get`
export const create = `${BASE}/create`
export const update = `${BASE}/update`
export const remove = `${BASE}/remove`
export const desactivate = `${BASE}/desactivate`
export const activate = `${BASE}/activate`

export const ticketAssign = `${BASE}/tickets/assign`
export const ticketChangeStatus = `${BASE}/tickets/changeStatus`
export const ticketClose = `${BASE}/tickets/close`
export const ticketReopen = `${BASE}/tickets/reopen`
export const ticketEscalate = `${BASE}/tickets/escalate`

// ─── Parámetros de tickets ────────────────────────────────────────────────
export const ticketModulos      = `${BASE}/tickets/modulos`
export const ticketEstados      = `${BASE}/tickets/estados`
export const ticketTiposContacto= `${BASE}/tickets/tipos-contacto`
export const ticketPrioridades  = `${BASE}/tickets/prioridades`
export const ticketSolicitudes  = `${BASE}/tickets/solicitudes`
export const ticketEscalationUsers = `${BASE}/tickets/escalation-users`
export const ticketClientesPagados = `${BASE}/tickets/clientes-pagados`
export const ticketClientesBase = `${BASE}/tickets/clientes`
export const clientes = `${BASE}/clientes`
export const inventoryUsers = `${BASE}/inventory/users`
export const inventoryTemplate = `${BASE}/inventory/template`
export const inventoryExport = `${BASE}/inventory/export`
export const inventoryImport = `${BASE}/inventory/import`
export const notificationsList = `${BASE}/notifications/list`
export const notificationsRead = `${BASE}/notifications/read`
export const notificationsReadAll = `${BASE}/notifications/read-all`
